import { useContext } from "react";
// my imports:
import { GameManager } from "@/app/lib/game-state/game-manager";
import { AnyGameObj } from "@/app/lib/game-state/game-types";
import UI from "@/app/lib/ui/ui";
import { Contexts } from "@/app/components/Context";
import { InternalRouter } from "@/app/lib/routing/internal-router";


export default function Debug() {

    const gameManager: GameManager | null = useContext(Contexts.GameManager);
    const activeGame: AnyGameObj | null = useContext(Contexts.ActiveGame);
    const ui: UI | null = useContext(Contexts.UI);

    if (!gameManager || !activeGame || !ui) {
        console.warn('bad context in Debug');
        return null;
    }

    const iRouter = new InternalRouter(gameManager, ui);

    if (ui.debugMode) {
        console.log(activeGame.state)
    }

    const debugString = JSON.stringify(activeGame.state);

    if (!ui.debugMode)
        return null;

    return(
        <div>
            <div onClick={() => activeGame.update(state => state.reveal(true))}>
                CHEAT
            </div>
            <div onClick={() => iRouter.toggleMode()}>
                TOGGLE
            </div>
            <div onClick={() => {
                ui.streakAnimations.reset();
                ui.setStreakFeedback('sad');
                ui.streakAnimations.feedback('sad');
            }}>
                ANIMATE 1
            </div>
            <div onClick={() => {
                ui.streakAnimations.increment();
                ui.setStreakFeedback('happy');
                ui.streakAnimations.feedback('happy');
            }}>
                ANIMATE 2
            </div>
            {false && debugString}
        </div>
    )
}